import {FuseRouteItemType} from '@fuse/utils/FuseUtils';

import {AUTH_ROLES} from '@/app/auth/authRoles';

import KycNotStartedPage from './KycNotStartedPage';

const KycNotStartedRoute: FuseRouteItemType = {
  path: '',
  element: <KycNotStartedPage />,
  auth: AUTH_ROLES.parent, // []
};

export default KycNotStartedRoute;
